import { ChangeEvent, FormEvent, useState } from 'react';

type FormOptions<T> = {
	initialValues?: Partial<T>;
	onSubmit?: (values: T) => Promise<void>;
};

interface FormValues<T> {
	values: T;
	handleChange: (e: FormChangeEvent) => void;
	handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
	setValue: (key: string, value: unknown) => void;
}

export type FormChangeEvent = ChangeEvent<HTMLInputElement & HTMLSelectElement>;

export function useForm<T extends Record<keyof T, unknown>>(options?: FormOptions<T>): FormValues<T> {
	const [values, setData] = useState<T>((options?.initialValues || {}) as T);

	const handleChange = (e: FormChangeEvent) => {
		const { name, value } = e.target;

		setData({
			...values,
			[name]: value,
		});
	};

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (options?.onSubmit) {
			void Promise.resolve(options.onSubmit(values));
		}
	};

	const setValue = (key: string, value: unknown) => {
		setData({
			...values,
			[key]: value,
		});
	};

	return {
		values,
		handleChange,
		handleSubmit,
		setValue,
	};
}
